







































import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class UTranslateInput extends Vue {
  // Props

  @Prop({ required: true })
  public readonly value!: any;

  @Prop({ default: false })
  public readonly autofocus!: boolean;

  @Prop({ default: false })
  public readonly isDisabled!: boolean;

  @Prop({ default: false })
  public readonly hasError!: boolean;

  @Prop({ default: true })
  public readonly isTranslatable!: boolean;

  // Computed

  public get canTranslate() {
    return (
      this.$userCan("create_object_translation") &&
      this.$userCan("get_object_translation") &&
      this.$userCan("list_object_translations")
    );
  }

  // Methods

  public onTranslate() {
    if (this.canTranslate) return this.$emit("translate");
  }
}
